import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./SecondStageSeparator.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";

import { trackPageVisit } from "../competency/PageTracker";



 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


              

function SecondStageSeparator() {

        useEffect(() => {
  
    trackPageVisit("SecondStageSeparator");
  
  }, []);

  const {  valves, toggleValve, transmitters} = useContext(WellContext);

  


  const DEFAULT_VALVES = {
  FCV_14001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_14002: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_14003: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_14004: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_14005: { mode: "Manual", opening: 0, sp: "", pv: "" },
};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("SecondStageSeparator_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_14001: { ...DEFAULT_VALVES.FCV_13001, ...parsed.FCV_14001 },
      FCV_14002: { ...DEFAULT_VALVES.FCV_13003, ...parsed.FCV_14002 },
      FCV_14003: { ...DEFAULT_VALVES.FCV_13005, ...parsed.FCV_14003 },
      FCV_14004: { ...DEFAULT_VALVES.FCV_13006, ...parsed.FCV_14004 },
      FCV_14005: { ...DEFAULT_VALVES.FCV_13006, ...parsed.FCV_14005 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("SecondStageSeparator_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


   // ================= INFLOW LOGIC from FIRST STAGE SEPARATOR to SECOND STAGE SEPARATOR CRUDE LEVEL TRANSMITTER =================

   const [PT_2936, setPT_2936] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2936")) || 0;
            setPT_2936(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

   const [FIC_2936, setFIC_2936] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2936")) || 0;
            setFIC_2936(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

     

      const isXV_14001Open = valves?.XV_14001 === false;

        const FIC_14010 = FIC_2936;
        const PT_14010 = PT_2936;


          // ================= CRUDE FLOW from FIRST STAGE SEPARATOR to SECOND STAGE SEPARATOR =================
              const [FIC_14001, setFIC_14001] = useState(() => {
                return Number(localStorage.getItem("FIC_14001")) || 0;
              });   
              const targetFIC_14001 = useMemo(() => {
                const fic = Number(transmitters?.FIC_12007 + FIC_14010?? 0);
                return valves?.XV_14001 === false ? fic: 0.03;
              }, [transmitters?.FIC_12007, valves?.XV_14001]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setFIC_14001(prev => {
                    const diff = targetFIC_14001 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetFIC_14001;
        
                    return prev + step;
                  });
                }, 500); // update speed
        
                return () => clearInterval(interval);
              }, [targetFIC_14001]);
        
              useEffect(() => {
                    localStorage.setItem("FIC_14001", FIC_14001);
                  }, [FIC_14001]);


        const inflows5 = (isXV_14001Open && FIC_14001 > 0)
        ? [FIC_14001 / 60]
        : [];          

       const waterFlow = FIC_14001 * 0.03 * 159.987 || 0;
       const inflows6 = (isXV_14001Open && waterFlow > 0)
        ? [waterFlow / 80]
        : [];


      const FIC_14002 = isXV_14001Open ? (FIC_14001 * 0.04 * 5.615) : 0;

      
           // First flow (direct from FCV)
        const targetFIC_14008 = isXV_14001Open
        ? FIC_14002 * ((valveData?.FCV_14001?.opening || 0) / 100)
        : 0;

         const [FIC_14008, setFIC_14008] = useState(() => {
        return Number(localStorage.getItem("FIC_14008")) || 0;
      }); 

    useEffect(() => {
        const interval = setInterval(() => {
          setFIC_14008(prev => {
            const diff = targetFIC_14008 - prev;

            // smoothing factor (tune this)
            const step = diff * 0.1;

            // snap when very close
            if (Math.abs(diff) < 0.001) return targetFIC_14008;

            return prev + step;
          });
        }, 200); // speed of update

        return () => clearInterval(interval);
      }, [targetFIC_14008]);

      useEffect(() => {
            localStorage.setItem("FIC_14008", FIC_14008);
          }, [FIC_14008]);


      const FIC_14003 = ((valveData?.FCV_14002?.opening || 0) / 100) * Number(transmitters?.FIC_13009 ?? 0);
       const PT_14003 = ((valveData?.FCV_14002?.opening || 0) / 100) * Number(transmitters?.PT_13009 ?? 0);


        // Remaining gas after first split
        const FIC_14004 = (FIC_14002 - FIC_14008) + FIC_14002;

          const { setTransmitters } = useContext(WellContext);
          useEffect(() => {
              setTransmitters(prev => ({
                ...prev,
                FIC_14004: FIC_14004
              }));
            }, [FIC_14004, setTransmitters]);


            const [TT_14001, setTT_14001] = useState(() => {
                return Number(localStorage.getItem("TT_14001")) || 0;
              });   
              const targetTT_14001 = useMemo(() => {
                const fic = Number(transmitters?.TT_12007a ?? 0);
                return valves?.XV_14001 === false ? fic : 0.03;
              }, [transmitters?.TT_12007a, valves?.XV_14001]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setTT_14001(prev => {
                    const diff = targetTT_14001 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetTT_14001;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetTT_14001]);
        
              useEffect(() => {
                    localStorage.setItem("TT_14001", TT_14001);
                  }, [TT_14001]);



            const [PT_14001, setPT_14001] = useState(() => {
                return Number(localStorage.getItem("PT_14001")) || 0;
              });   
              const targetPT_14001 = useMemo(() => {
                const fic = Number(transmitters?.PT_12002 ?? 0);
                return valves?.XV_14001 === false ? fic  * 0.5 : 0.03;
              }, [transmitters?.PT_12002, valves?.XV_14001]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setPT_14001(prev => {
                    const diff = targetPT_14001 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetPT_14001;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetPT_14001]);
        

            
            const TT_14002 = isXV_14001Open ? TT_14001 - (TT_14001 * 0.023) : 22;
            const PT_14002 = isXV_14001Open ? PT_14001 - (PT_14001 * 0.0053) : 0.03;

              

          const TT_14004 = isXV_14001Open ? TT_14002 - (TT_14002 * 0.0098) : 0.003;
          const PT_14004 = isXV_14001Open ? PT_14002 - (PT_14002 * 0.0698) : 0.003;

             
  // ================= DECREMENTING IMPURITY LEVEL OF SECOND STAGE SEPARATOR CHAMBER =================
        const impurityFlowRate2ndStageSeparator = 250.675;
       const FIC_14005 = impurityFlowRate2ndStageSeparator * ((valveData?.FCV_14003?.opening || 0) / 100);



       
      
// =================  DECREMENTING CRUDE LEVEL OF FIRST STAGE SEPARATOR CHAMBER =================

      const isXV_14002Open = valves?.XV_14002 === false;

      const crudeFlowRate2ndStageSeparator = 300.56
       const FIC_14007 = isXV_14002Open ? crudeFlowRate2ndStageSeparator * ((valveData?.FCV_14004?.opening || 0) / 100) : 0;

      const FIC_14007a = isXV_14002Open ? FIC_14007 * 24 : 0;
       const crudeDensity1 = 855.565;
      const FIC_14007b = isXV_14002Open ? (FIC_14007 / 1000 / 60) * crudeDensity1 : 0;

      const TT_14007a = isXV_14002Open ? TT_14002 -(TT_14002 * 0.098) :22;


      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          FIC_14007: FIC_14007
        }));
      }, [FIC_14007]);

       // ================= DECREMENTING WATER LEVEL OF FIRST STAGE SEPARATOR CHAMBER =================

      const isXV_14003Open = valves?.XV_14003 === false;

      const waterFlowRate2ndStageSeparator = 159.942;
       const FIC_14006 = isXV_14003Open ? (waterFlowRate2ndStageSeparator * ((valveData?.FCV_14005?.opening || 0) / 100)) : 0;
       const FIC_14006a = isXV_14003Open ? FIC_14006 * 24 : 0;

       const waterDensity1 = 993.565;
      const FIC_14006b = isXV_14003Open ? (FIC_14006 / 1000 / 60) * waterDensity1 : 0;
       
      const TT_14006a = isXV_14003Open ? TT_14002 -(TT_14002 * 0.198) :22;

        
      useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              FIC_14006: FIC_14006
            }));
          }, [FIC_14006]);

          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              TT_14006a: TT_14006a
            }));
          }, [TT_14006a]);

        useEffect(() => {
                localStorage.setItem("TT_14007a", TT_14007a);
              }, [TT_14007a]);



          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              PT_14002: PT_14002
            }));
          }, [PT_14002]);


          useEffect(() => {
                    localStorage.setItem("FIC_14004", FIC_14004);
                  }, [FIC_14004]);

          useEffect(() => {
                    localStorage.setItem("PT_14004", PT_14004);
                  }, [PT_14004]);

          useEffect(() => {
                    localStorage.setItem("TT_14004", TT_14004);
                  }, [TT_14004]);




          /* 🔥 ALARM ENGINE TAGS */
              
                      const { evaluateTag } = useContext(AlarmContext);
              
                      useEffect(() => {
                        evaluateTag("FIC_14001", FIC_14001);

      
      
                      }, [FIC_14001, ]);
              

     



  
  return (
    
    <div className="SecondStageSeparator-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "325px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2.2px 203px"
      }}>
        SECOND STAGE SEPARATOR
      </h2>


      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-14001 */}
      <Valve
        className="XV-14001"
        tag="XV_14001"
        x={195}
        y={144}
        isClosed={valves.XV_14001}
        toggle={toggleValve}
      />

      {/* XV-14002 */}
      <Valve
        className="XV-14002"
        tag="XV_14002"
        x={568}
        y={417}
        isClosed={valves.XV_14002}
        toggle={toggleValve}
        r={90}
      />

      
      {/* XV-14003 */}
      <Valve
        className="XV-14003"
        tag="XV_14003"
        x={438}
        y={480}
        isClosed={valves.XV_14003}
        toggle={toggleValve}
        r={90}
      />


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-14001 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-14001"
          style={{ position: "absolute", left: 727, top: 104, transform: "rotate(270deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_14001")}>
          
          <defs>
            <linearGradient id="metal_14001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_14001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_14001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-14002 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-14002"
          style={{ position: "absolute", left: 840, top: 158 }}  onClick={() => openPanel("FCV_14002")}>
          
          <defs>
            <linearGradient id="metal_14002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_14002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_14002)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>
        


        {/* FCV-14003 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-14003"
          style={{ position: "absolute", left: 229, top: 520}}  onClick={() => openPanel("FCV_14003")}>
          
          <defs>
            <linearGradient id="metal_14003">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_14003)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_14003)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        {/* FCV-14004 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-14004"
          style={{ position: "absolute", left: 730, top: 627}}  onClick={() => openPanel("FCV_14004")}>
          
          <defs>
            <linearGradient id="metal_14004">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_14004)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_14004)" stroke="#7f8c8d" strokeWidth="2" />



        </svg>
        {/* FCV-14005 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-14005"
          style={{ position: "absolute", left: 594, top: 700}}  onClick={() => openPanel("FCV_14005")}>
          
          <defs>
            <linearGradient id="metal_14005">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_14005)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_14005)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

      
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_14001?.opening || 0)}
        x={779}
        y={120}
      />

      <ValveOutput
        value={Number(valveData?.FCV_14002?.opening || 0)}
        x={858}
        y={208}
      />
      <ValveOutput
        value={Number(valveData?.FCV_14003?.opening || 0)}
        x={253}
        y={560}
      />

      <ValveOutput
        value={Number(valveData?.FCV_14004?.opening || 0)}
        x={750}
        y={676}
      />

      <ValveOutput
        value={Number(valveData?.FCV_14005?.opening || 0)}
        x={612}
        y={747}
      />

      

    <Transmitter
      value={FIC_14001}
      x={260}
      y={129}
      unit="BPM"
      max={300}
      HH={294}
      H={280}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM 1ST STAGE SEPARATOR"
      tag="FIC-14001"
    />

    <Transmitter
      value={FIC_14002}
      x={622}
      y={129}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT GAS OUTLET OF 2ND STAGE SEPARATOR TO MP COMPRESSOR SUCTION COOLER"
      tag="FIC-14002"
    />

    <Transmitter
      value={FIC_14003}
      x={1030}
      y={129}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS FROM TEST SEPARATOR"
      tag="FIC-14003"
    />

    <Transmitter
      value={FIC_14008}
      x={1157}
      y={90}
      unit="SCF/S"
      max={50}
      HH={45}
      H={40}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT 2ND STAGE SEPARATOR PSV OUTLET LINE TO FLARE HEADER"
      tag="FIC-14008"
    />

     <Transmitter
      value={FIC_14004}
      x={1000}
      y={504}
      unit="SCF/S"
      max={150}
      HH={145}
      H={140}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS TO MP COMPRESSOR SUCTION COOLER"
      tag="FIC-14004"
     />

    <Transmitter
      value={FIC_14005}
      x={154}
      y={505}
      unit="LPM"
      max={20}
      HH={15}
      H={10}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF WATER AND SEDIMENT TO CLOSE DRAIN FROM 2ND STAGE SEPARATOR"
      tag="FIC-14005"
     />

     <Transmitter
      value={PT_14003}
      x={940}
      y={129}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS FROM TEST SEPARATOR"
      tag="PT-14003"
     />

     <Transmitter
      value={TT_14001}
      x={110}
      y={129}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF CRUDE FROM 1ST STAGE SEPARATOR TO INLET OF N2ND STAGE PRODUCTION SEPARATOR"
      tag="TT-14001"
     />

     <Transmitter
      value={TT_14002}
      x={460}
      y={164}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF GAS AT GAS OUTLET OF 2ND STAGE SEPARATOR TO MP COMPRESSOR SUCTION COOLER"
      tag="TT-14002"
     />

     <Transmitter
      value={PT_14001}
      x={360}
      y={164}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF 2ND STAGE SEPARATOR VESSEL"
      tag="PT-14001"
     />

     <Transmitter
      value={PT_14002}
      x={550}
      y={129}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS AT GAS OUTLET OF 2ND STAGE SEPARATOR TO MP COMPRESSOR SUCTION COOLER"
      tag="PT-14002"
     />

     <Transmitter
      value={TT_14004}
      x={1099}
      y={504}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF GAS TO MP COMPRESSOR SUCTION COOLER"
      tag="TT-14004"
     />

     <Transmitter
      value={PT_14004}
      x={872}
      y={504}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS TO MP COMPRESSOR SUCTION COOLER"
      tag="PT-14004"
     />

    <Transmitter
      value={FIC_14007}
      x={625}
      y={575}
      unit="BPM"
      max={300}
      HH={285}
      H={270}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 2ND STAGE SEPARATOR TO 3RD STATE SEPARATOR"
      tag="FIC-14007A"
    />

    <Transmitter
      value={FIC_14007a}
      x={625}
      y={585}
      unit="BPD"
      max={7750}
      HH={7745}
      H={7240}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 2ND STAGE SEPARATOR TO 3RD STATE SEPARATOR"
      tag="FIC-14007A"
    />

    <Transmitter
      value={FIC_14007b}
      x={625}
      y={595}
      unit="kg/m3"
      max={5}
      HH={4.23}
      H={3.8}
      L={0.05}
      LL={0.003}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 2ND STAGE SEPARATOR TO 3RD STATE SEPARATOR"
      tag="FIC-14007B"
    />

    <Transmitter
      value={TT_14007a}
      x={625}
      y={606}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 2ND STAGE SEPARATOR TO 3RD STATE SEPARATOR"
      tag="TT-14007A"
    />

    <Transmitter
      value={FIC_14006}
      x={465}
      y={575}
      unit="LPM"
      max={20}
      HH={18}
      H={16}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 2ND STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-14006"
    />

    <Transmitter
      value={FIC_14006a}
      x={465}
      y={585}
      unit="LPD"
      max={400}
      HH={385}
      H={350}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 2ND STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-14006A"
    />

    <Transmitter
      value={FIC_14006b}
      x={465}
      y={595}
      unit="kg/m3"
      max={2}
      HH={1.5}
      H={1.8}
      L={0.08}
      LL={0.03}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 2ND STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-14006B"
    />

    <Transmitter
      value={TT_14006a}
      x={465}
      y={606}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 2ND STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="TT-14006A"
    />


    <Transmitter
      value={FIC_14010}
      x={83}
      y={332}
      unit="BPM"
      max={120}
      HH={110}
      H={95}
      L={0.08}
      LL={0.03}
      c="lime"
      description="FLOWRATE OF RECOVERED CRUDE FROM OILY WATER TANK TO 2ND STAGE PRODUCTION SEPARATOR"
      tag="FIC-14010"
    />

    <Transmitter
      value={PT_14010}
      x={173}
      y={247}
      unit="MPa"
      max={5}
      HH={4}
      H={3}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF RECOVERED CRUDE FROM OILY WATER TANK TO 2ND STAGE PRODUCTION SEPARATOR"
      tag="PT-14010"
     />

     
      <LevelTransmitterIndicator
      tag="LT_14001"
      totalLevel={10000}
      inflows={[
        (valves?.XV_14001 === false ? FIC_14001 / 60 : 0)
      ]}
      outflows={[FIC_14007/60]}
      responseFactor={0.05}
      columnX={562}
      columnY={245}
      columnWidth={30}
      columnHeight={120}
      textX={652}
      textY={285}
      showFlow={true}
    />

      <LevelTransmitterIndicator
      tag="LT_14002"
      totalLevel={10000}
      inflows={inflows6}
      outflows={[FIC_14006]}
      
      responseFactor={0.05}
      columnX={430}
      columnY={315}
      columnWidth={30}
      columnHeight={120}
      textX={348}
      textY={393}
      showFlow={true}
    />


    </div>
  );
}

export default SecondStageSeparator;